const eventsSubscriptionNames = {
	viewModalPremiumActive: 'view-modal-premium-active',
	clickButtonShareFeedback: 'click-button-share-feedback',
	clickButtonSubmitFeedback: 'click-button-submit-feedback-sub',
	clickButtonCancelRenewalFirst: 'click-button-cancel-renewal-first',
	clickButtonKeepBenefitsCancelSub: 'click-button-keep-benefits-cancelsub',
	clickButtonImSureCancelSub: 'click-button-imsure-cancelsub',
	viewModalUnsubscriptionOffer: 'unsubscribe-offer_popup-show',
	clickButtonDeclineUnsubscriptionOffer:
		'unsubscribe-offer_popup_decline-click',
	clickButtonAcceptUnsubscriptionOffer:
		'unsubscribe-offer_popup_activate-click',
	clickButtonCancelCancelSub: 'click-button-cancel--cancelsub',
	clickButtonNotNowCancelSub: 'click-button-not-now-cancelsub',
	viewModalCanceledPremiumCancelSub: 'view-modal-canceled-premium-cancelsub',
	clickButtonRestoreSubscription:
		'unsubscribe-cancelled_subscription_popup_reactivate_btn-click',
	clickElementCloseCancelSub: 'click-element-close-cancelsub',
	clickLinkContactSupportCancelSub: 'click-link-contact-support-cancelsub',
	clickLinkRefundPolicyCancelSub: 'click-link-refund-policy-cancelsub',
};

export default eventsSubscriptionNames;
